import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

const active = css``
const arrow = css`
  transition: transform 0.25s ease-out, -webkit-transform 0.25s ease-out;
  &.${active} {
    transform: rotate(180deg);
  }
`
const separator = css`
  border-block-end: ${spacing(0.25)} solid rgba(255, 255, 255, 0.1);
`

export const classes = {
  active,
  arrow,
  separator,
  root: css`
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    inline-size: 100%;
    &:not(:first-child) {
      padding-block-start: ${spacing(1.25)};
    }
    &:not(:last-child) {
      padding-block-end: ${spacing(1.25)};
    }

    &.${separator} {
      &:not(:first-child) {
        padding-block-start: ${spacing(2.25)};
      }
      &:not(:last-child) {
        padding-block-end: ${spacing(2.25)};
      }
    }
  `,
  last: css`
    border: 0;
  `,
  headerContainer: css`
    position: relative;
    inline-size: 100%;
    cursor: pointer;
    & .${arrow} {
      margin: 0;
      inline-size: ${spacing(2)};
      block-size: auto;
    }
  `,
  header: css`
    margin-inline-end: ${spacing(3.75)};
  `,
  description: css`
    inline-size: 100%;
    max-block-size: 0;
    overflow: hidden;
    opacity: 0;
    transition: all 0.25s;

    &.${active} {
      max-block-size: ${spacing(100)};
      opacity: 1;
      margin-block-start: ${spacing(2)};
    }
  `,
}
